import { Box, Grid, useTheme } from "@mui/material";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import Public from '@mui/icons-material/Public';
import LibraryBooks from '@mui/icons-material/LibraryBooks';

import LeadCard from "page-sections/dashboards/CRM/LeadCard";
import LongCard from "page-sections/dashboards/CRM/LongCard";
import DataTableV2 from "pages/data-table/data-table-v2";
import Chapters from "./chapters";
import BusinessDoneCard from "./BDCard";
import ChapterLongCard from "./LCard";
import BadgeIcon from "@mui/icons-material/Badge";
import GroupsIcon from '@mui/icons-material/Groups';
import { useState, useEffect } from "react";
import { usePageTitle } from "contexts/PageTitleContext";

const CT = () => {
  const theme = useTheme();
  const [summaryData, setSummaryData] = useState(null);
  const { setPageTitle } = usePageTitle();
  useEffect(() => {
    setPageTitle('Chapter Management');
}, [setPageTitle]);

  const list1 = summaryData?.totals ? [
    {
      id: 1,
      amount: summaryData.totals.total_attendance,
      Icon: BadgeIcon,
      title: "Total Attendance",
      color: theme.palette.primary.main
    }, 
    {
      id: 2,
      amount: summaryData.totals.total_members,
      Icon: GroupsIcon,
      title: "Total Members",
      color: theme.palette.info.main
    }, 
    {
      id: 3,
      amount: summaryData.totals.total_chapters,
      Icon: LibraryBooks,
      title: "Total Chapters",
      color: theme.palette.text.disabled
    }
  ] : [];
  
  return <Box pt={2} pb={4}>
      <Grid container spacing={3}>
        <Grid item md={4} xs={12}>
          <BusinessDoneCard businessDone={summaryData?.totals?.total_business_done || 0} />
        </Grid>

        <Grid item md={8} xs={12}>
          <ChapterLongCard list={list1} />
        </Grid>

        <Grid item xs={12}>
          <Chapters onDataFetch={setSummaryData} />
        </Grid>

       
      </Grid>
    </Box>;
};

export default CT;